import _createForOfIteratorHelper from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import dayjs from 'dayjs';
export default {
  name: 'mng_user',
  data: function data() {
    return {
      dayjs: dayjs,
      currentUser: localStorage.getItem('userId'),
      pageConfig: {
        editPageName: '用户',
        addFunName: 'mngUserAdd',
        modifyFunName: 'mngUserModify',
        queryFunName: 'mngUserQueryJoinIntroduce',
        detailFunName: 'mngUserDetail',
        disableFunName: 'mngUserDisable',
        unDisableFunName: 'mngUserUnDisable',
        unLockFunName: 'mngUserUnLock',
        resetPasswordFunName: 'mngUserResetPassword',
        addBalanceFunName: 'mngUserAddBalance',
        subBalanceFunName: 'mngUserSubBalance',
        clearAuthFunName: 'mngUserClearAuth',
        dicTreeFunName: 'mngDictionaryLowerTree'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        category: null,
        userType: null,
        state: null,
        sortField: 'create_time',
        introduceUserNickname: null
      },
      formData: {
        id: null,
        category: null,
        state: 'active',
        account: null,
        nickname: null,
        name: null,
        gender: null,
        birthdate: null,
        image: null,
        phone: null,
        remark: null,
        mobileId: null
      },
      formBalanceData: {
        id: null,
        currentBalance: null,
        operationType: null,
        balance: null,
        content: null
      },
      rules: {
        account: [{
          required: true,
          message: '帐号不能为空',
          trigger: 'blur'
        }],
        category: [{
          required: true,
          message: '类别不能为空',
          trigger: 'blur'
        }]
      },
      balanceRules: {
        balance: [{
          required: true,
          message: '变更余额不能为空',
          trigger: 'blur'
        }, {
          pattern: /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/,
          message: '变更余额必须为有效金额',
          trigger: 'blur'
        }],
        content: [{
          required: true,
          message: '变更余额原因不能为空',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      balanceDialogShow: false,
      balanceDialogTitle: '',
      formLabelWidth: '70px',
      formLabelLowWidth: '50px',
      formBalanceLabelWidth: '100px',
      emptyFormData: {},
      emptyBalanceFormData: {},
      detailShow: false,
      detail: {}
    };
  },
  mounted: function mounted() {
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.emptyBalanceFormData = JSON.parse(JSON.stringify(this.formBalanceData));
    this.query();
  },
  watch: {
    detailShow: function detailShow(to) {
      if (!to) {
        this.detail = {};
      }
    }
  },
  methods: {
    detailClick: function detailClick(data) {
      this.detail = data;
      this.detailShow = true;
    },
    beforeCommand: function beforeCommand(index, row, command) {
      return {
        index: index,
        row: row,
        command: command
      };
    },
    moreButton: function moreButton(command) {
      switch (command.command) {
        case 'unLock':
          // 解除锁定
          this.unLock(command.row.id);
          break;
        case 'disable':
          // 封禁用户
          this.disableUser(command.row.id);
          break;
        case 'unDisable':
          // 解封用户
          this.unDisableUser(command.row.id);
          break;
        case 'resetPassword':
          // 重置密码
          this.resetPassword(command.row.id);
          break;
        case 'addBalance':
          // 增加余额
          this.addBalance(command.row.id);
          break;
        case 'subBalance':
          // 扣减余额
          this.subBalance(command.row.id);
          break;
        case 'clear':
          // 清理用户
          this.clearUser(command.row.id);
          break;
      }
    },
    unLock: function unLock(userId) {
      var _this = this;
      this.$confirm('确定解锁当前用户吗').then(function () {
        _this.$api[_this.pageConfig.unLockFunName](userId).then(function (res) {
          if (res.data) {
            _this.$message.success('解锁成功');
            _this.query();
          } else {
            _this.$message.error('解锁失败');
          }
        });
      });
    },
    disableUser: function disableUser(userId) {
      var _this2 = this;
      this.$confirm('确定封禁当前用户吗').then(function () {
        _this2.$api[_this2.pageConfig.disableFunName](userId).then(function (res) {
          if (res.data) {
            _this2.$message.success('封禁成功');
            _this2.query();
          } else {
            _this2.$message.error('封禁失败');
          }
        });
      });
    },
    unDisableUser: function unDisableUser(userId) {
      var _this3 = this;
      this.$confirm('确定解禁当前用户吗').then(function () {
        _this3.$api[_this3.pageConfig.unDisableFunName](userId).then(function (res) {
          if (res.data) {
            _this3.$message.success('解禁成功');
            _this3.query();
          } else {
            _this3.$message.error('解禁失败');
          }
        });
      });
    },
    resetPassword: function resetPassword(userId) {
      var _this4 = this;
      this.$confirm('确定重置当前用户密码吗').then(function () {
        _this4.$api[_this4.pageConfig.resetPasswordFunName](userId).then(function (res) {
          if (res.data) {
            _this4.$message.success('重置成功');
            _this4.query();
          } else {
            _this4.$message.error('重置失败');
          }
        });
      });
    },
    addBalance: function addBalance(userId) {
      var _this5 = this;
      this.$api[this.pageConfig.detailFunName](userId).then(function (res) {
        _this5.formBalanceData.id = res.data.id;
        _this5.formBalanceData.operationType = 'add';
        _this5.formBalanceData.currentBalance = res.data.balanceCirculate;
        _this5.balanceDialogTitle = (res.data.nickname || res.data.account) + ' 增加余额';
        _this5.balanceDialogShow = true;
      });
    },
    subBalance: function subBalance(userId) {
      var _this6 = this;
      this.$api[this.pageConfig.detailFunName](userId).then(function (res) {
        _this6.formBalanceData.id = res.data.id;
        _this6.formBalanceData.operationType = 'sub';
        _this6.formBalanceData.currentBalance = res.data.balanceCirculate;
        _this6.balanceDialogTitle = (res.data.nickname || res.data.account) + ' 扣减余额';
        _this6.balanceDialogShow = true;
      });
    },
    clearUser: function clearUser(userId) {
      var _this7 = this;
      this.$confirm('确定清除用户吗？用户清除后将不能恢复').then(function () {
        _this7.$confirm('请再次确认，是否清除当前用户？').then(function () {
          _this7.$confirm('请谨慎操作！！！最后确认是否清除当前用户？').then(function () {
            _this7.$api[_this7.pageConfig.clearAuthFunName](userId).then(function (res) {
              if (res.data) {
                _this7.$message.success('清除成功');
                _this7.query();
              } else {
                _this7.$message.error('清除失败');
              }
            });
          });
        });
      });
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      if (paramData.birthdate) {
        paramData.birthdate = paramData.birthdate.toString();
      }
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    initBalanceFormData: function initBalanceFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formBalanceData = paramData;
      if (typeof this.$refs['formBalanceDataVerify'] !== 'undefined') {
        this.$refs['formBalanceDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    upload: function upload(_ref) {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file;
              _this8.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this8.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this8.formData.image = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    previewFile: function previewFile() {
      window.open(this.formData.image);
    },
    removeFile: function removeFile() {
      this.formData.image = '';
    },
    query: function query() {
      var _this9 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(res) {
          var _iterator, _step, item;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _iterator = _createForOfIteratorHelper(res.data);
                _context3.prev = 1;
                _iterator.s();
              case 3:
                if ((_step = _iterator.n()).done) {
                  _context3.next = 14;
                  break;
                }
                item = _step.value;
                if (!item.introduceUser) {
                  _context3.next = 11;
                  break;
                }
                _context3.next = 8;
                return _this9.introduce(item.introduceUser);
              case 8:
                item.introduceUserInfo = _context3.sent;
                _context3.next = 12;
                break;
              case 11:
                item.introduceUserInfo = null;
              case 12:
                _context3.next = 3;
                break;
              case 14:
                _context3.next = 19;
                break;
              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3["catch"](1);
                _iterator.e(_context3.t0);
              case 19:
                _context3.prev = 19;
                _iterator.f();
                return _context3.finish(19);
              case 22:
                _this9.tableData = res.data || [];
                _this9.totalCount = res.count;
                _this9.queryLoading = false;
              case 25:
              case "end":
                return _context3.stop();
            }
          }, _callee3, null, [[1, 16, 19, 22]]);
        }));
        return function (_x2) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    introduce: function introduce(id) {
      var _this10 = this;
      return new Promise(function (resolve, reject) {
        _this10.$api[_this10.pageConfig.detailFunName](id).then(function (res) {
          if (res.data) {
            resolve(res.data);
          }
        });
      });
    },
    submitBalanceFormData: function submitBalanceFormData() {
      var _this11 = this;
      this.$refs['formBalanceDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this11.formBalanceData.operationType === 'add') {
            _this11.$api[_this11.pageConfig.addBalanceFunName](_this11.formBalanceData.id, _this11.formBalanceData.balance, _this11.formBalanceData.content).then(function (res) {
              if (res.data) {
                _this11.$message.success('增加成功');
                _this11.initBalanceFormData(_this11.emptyBalanceFormData);
                _this11.balanceDialogShow = false;
                _this11.query();
              } else {
                _this11.$message.error('增加失败');
              }
            });
          } else {
            _this11.$api[_this11.pageConfig.subBalanceFunName](_this11.formBalanceData.id, _this11.formBalanceData.balance, _this11.formBalanceData.content).then(function (res) {
              if (res.data) {
                _this11.$message.success('扣减成功');
                _this11.initBalanceFormData(_this11.emptyBalanceFormData);
                _this11.balanceDialogShow = false;
                _this11.query();
              } else {
                _this11.$message.error('扣减失败');
              }
            });
          }
        }
      });
    },
    closeBalanceEditDialogShow: function closeBalanceEditDialogShow() {
      this.balanceDialogTitle = '';
      this.balanceDialogShow = false;
      this.initBalanceFormData(this.emptyBalanceFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};